<header class="bg-ds-surface border-b border-ds-border shadow-sm">
  <div class="w-full max-w-[98%] mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-12">
      <div class="flex items-stretch h-full min-w-0">
        <div class="flex-shrink-0 flex items-center">
          <img src="/icon.png" alt="OCR Prime Logo" class="w-6 h-6 mr-2">
          <h1 class="text-sm font-semibold font-data tracking-tight text-ds-text whitespace-nowrap" data-testid="header-app-title">OCR Prime Admin</h1>
        </div>
        <!-- Navigation Menu -->
        <nav class="ml-6 flex items-stretch gap-1">
          <a
            data-testid="header-nav-ocr-history"
            routerLink="/ocr-history"
            routerLinkActive="!text-ds-primary !border-ds-primary font-semibold"
            class="flex items-center px-3 text-sm font-medium text-ds-text-muted hover:text-ds-primary border-b-2 border-transparent transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary focus-visible:ring-inset"
          >
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] !leading-[18px] mr-1 align-middle">history</mat-icon>
            <span class="hidden md:inline">OCR History</span>
            <span class="sr-only md:hidden">OCR History</span>
          </a>
          <a
            data-testid="header-nav-templates"
            routerLink="/templates"
            routerLinkActive="!text-ds-primary !border-ds-primary font-semibold"
            class="flex items-center px-3 text-sm font-medium text-ds-text-muted hover:text-ds-primary border-b-2 border-transparent transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary focus-visible:ring-inset"
          >
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] !leading-[18px] mr-1 align-middle">description</mat-icon>
            <span class="hidden md:inline">Templates</span>
            <span class="sr-only md:hidden">Templates</span>
          </a>
          <a
            data-testid="header-nav-schema"
            routerLink="/fields"
            routerLinkActive="!text-ds-primary !border-ds-primary font-semibold"
            class="flex items-center px-3 text-sm font-medium text-ds-text-muted hover:text-ds-primary border-b-2 border-transparent transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary focus-visible:ring-inset"
          >
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] !leading-[18px] mr-1 align-middle">schema</mat-icon>
            <span class="hidden lg:inline">Schema Management</span>
            <span class="hidden md:inline lg:hidden">Schema</span>
            <span class="sr-only md:hidden">Schema Management</span>
          </a>
          <a
            data-testid="header-nav-monitoring"
            routerLink="/monitoring"
            routerLinkActive="!text-ds-primary !border-ds-primary font-semibold"
            class="flex items-center px-3 text-sm font-medium text-ds-text-muted hover:text-ds-primary border-b-2 border-transparent transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary focus-visible:ring-inset"
          >
            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] !leading-[18px] mr-1 align-middle">monitoring</mat-icon>
            <span class="hidden md:inline">Monitoring</span>
            <span class="sr-only md:hidden">Monitoring</span>
          </a>
        </nav>
      </div>
      <div class="flex items-center gap-2">
        <span class="hidden lg:inline text-xs text-ds-text-muted font-data" data-testid="header-user-email">{{ userInfo?.email }}</span>
        <!-- Theme Toggle Button -->
        <button
          data-testid="header-toggle-theme-btn"
          (click)="toggleTheme()"
          class="inline-flex items-center justify-center w-8 h-8 rounded-ds-sm cursor-pointer text-ds-text-muted hover:text-ds-accent hover:bg-ds-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary transition-colors duration-150"
          aria-label="Toggle Theme"
        >
          <!-- Sun icon for dark mode -->
          @if (isDarkMode) {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"></path>
            </svg>
          }
          <!-- Moon icon for light mode -->
          @if (!isDarkMode) {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"></path>
            </svg>
          }
        </button>
        <button
          data-testid="header-add-passkey-btn"
          (click)="addPasskey()"
          class="inline-flex items-center justify-center w-8 h-8 rounded-ds-sm cursor-pointer text-ds-text-muted hover:text-ds-accent hover:bg-ds-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary transition-colors duration-150"
          aria-label="Set up a passkey"
          title="Set up a passkey"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
          </svg>
        </button>
        <button
          data-testid="header-logout-btn"
          (click)="logout()"
          class="inline-flex items-center justify-center w-8 h-8 rounded-ds-sm cursor-pointer text-ds-text-muted hover:text-ds-danger hover:bg-ds-surface-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ds-secondary transition-colors duration-150"
          aria-label="Logout"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
        </button>
      </div>
    </div>
  </div>
</header>
